import styled from 'styled-components';
import {
  red,
  white,
  lightGrey,
  blue,
  teko,
  backgroundGrey,
} from '../../../utils/theme';
import { tablet } from '../../../utils/breakpoints';

export const DropdownParent = styled.div`
  /* @media(min-width: ${tablet.min}px) {
    margin: 0 -60px;
  } */
`;

export const TabContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: stretch;
  align-items: stretch;
  background: ${white};
  webkit-transition: .5s all 0s cubic-bezier(0.23, 1, 0.32, 1),0.05s color,0s background;
  transition: .5s all 0s cubic-bezier(0.23, 1, 0.32, 1),0.05s color,0s background;

  &.expanded {
    position: fixed;
    top: 93px;
    left: 0px;
    height: 10vw;
    min-height: 110px;
    max-height: 180px;
    width: 100%;
    z-index: 5;
    border-top: 3px solid rgb(233, 233, 233);
    border-bottom: 5px solid ${red};
  }

  &.collapsed {
    height: 150px;
    margin-top: 50px;
  }

  &.minimized {
    height: 60px;
    min-height: 60px;
  }
`;

export const Placeholder = styled.div`
  min-height: 110px;
  max-height: 180px;
  height: 10vw;

  &.minimized {
    height: 60px;
    min-height: 0;
  }
`;

export const Dropdown = styled.div`
  height: 40px;
  border-top: 1px solid ${lightGrey};
  border-bottom: 1px solid ${lightGrey};
  padding: 0px 39px;
  margin-bottom: 54px;
  position: relative;

  &.expanded {
    margin-bottom: 0px;
  }

  p {
      font-size: 28px;
      ${teko}
      color: ${blue};
      line-height: 45px;
      text-align: left;
      -ms-transform: skewX(-7deg); /* IE 9 */
      -webkit-transform: skewX(-7deg); /* Safari */
      transform: skewX(-7deg); /* Standard syntax */
      text-transform: uppercase;
  }

  img {
    position: absolute;
    right: 39px;
    top: 17px;
    webkit-transition: .5s all 0s cubic-bezier(0.23, 1, 0.32, 1),0.05s color,0s background;
    transition: .5s all 0s cubic-bezier(0.23, 1, 0.32, 1),0.05s color,0s background;

    &.open {
      transform: rotate(180deg);
    }
  }
`;

export const DropdownContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin: -54px 0 54px 0;
  background: ${backgroundGrey};
  max-height: 0px;
  webkit-transition: .5s all 0s cubic-bezier(0.23, 1, 0.32, 1),0.05s color,0s background;
  transition: .5s all 0s cubic-bezier(0.23, 1, 0.32, 1),0.05s color,0s background;
  overflow: hidden;

  &.expanded {
    margin: 0px;
  }

  &.open {
    overflow: auto;
    max-height: 175px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/city-selector/styles/city-selector.style.js